import { render } from "./Yllapito.vue?vue&type=template&id=0aedd8aa&ts=true"
import script from "./Yllapito.vue?vue&type=script&lang=ts"
export * from "./Yllapito.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__